import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { IStockTransactionMetaData } from '@phoenix/common';
import { ButtonModule } from 'primeng/button';
import { TimelineModule } from 'primeng/timeline';
import { TooltipModule } from 'primeng/tooltip';
import { EditLinks } from '../../../../../@core/constants/edit-links';
import { I18nService } from '../../../../../@core/services/i18n/i18n.service';
import { GET_STOCK_TRANSACTIONS_PRODUCT_TIMELINE } from '../../../../../data/definitions/warehouse-definition';
import { StockTransaction, StockTransactionSearchInput } from '../../../../../generated/generated-types';
import { StockTransactionService } from '../../../../warehouse/services/stock-transaction.service';

@Component({
  selector: 'app-widget-product-storage-timeline',
  templateUrl: './widget-product-storage-timeline.component.html',
  styleUrls: ['./widget-product-storage-timeline.component.scss'],
  providers: [StockTransactionService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    TranslatePipe,
    ButtonModule,
    TimelineModule,
    RouterModule,
    TooltipModule,
  ]
})
export class WidgetProductStorageTimelineComponent implements OnChanges {

  @Input()
  productId: string;

  si: StockTransactionSearchInput = {}

  items: StockTransaction[] = [];

  skip = 0;
  take = 15;
  totalCount = 0;

  initialLoadDone = false;

  isLoading = false;

  constructor(
    private warehouseService: StockTransactionService,
    private cdRef: ChangeDetectorRef,
    private i18n: I18nService,
  ) {

  }

  ngOnChanges(change: SimpleChanges) {
    if (change.productId) {
      this.si.productIds = [change.productId.currentValue];
      this.reload(); // for now
    }
  }

  async load() {
    this.isLoading = true;
    this.si.take = this.take;
    this.si.skip = this.skip;
    this.cdRef.detectChanges();
    let res = await this.warehouseService.getItems(this.si, {
      fragment: GET_STOCK_TRANSACTIONS_PRODUCT_TIMELINE
    }).mapSingle(x => x.getStockTransactions).toPromise();
    this.items = [...res.items as StockTransaction[]];
    this.totalCount = res.totalItems;
    this.initialLoadDone = true;
    this.isLoading = false;
    this.cdRef.detectChanges();
  }

  async loadMore() {
    this.skip += this.take;
    this.load();
  }

  async reload() {
    this.skip = 0;
    await this.load();
  }

  getDocumentLink(item: StockTransaction) {
    if (item?.getDocumentLineItem?.document ?? (item?.metaData as IStockTransactionMetaData)?.undoInformation?.documentId) {
      return EditLinks.DOCUMENT + "/" + (item.getDocumentLineItem?.document?.id ?? item.metaData?.undoInformation?.documentId);
    }
  }

  getCreatorName(item: StockTransaction) {
    if (item.createdBy?.activeEmployee)
      return [item.createdBy?.activeEmployee?.name, item.createdBy?.activeEmployee?.lastName].filter(x => x).join(' ');

    if (item.createdBy?.identifier)
      return item.createdBy?.identifier;

    return this.i18n.translate('common.unknown');
  }
}
